module.exports = __webpack_public_path__ + "media/flags/017-germany-599e2907.svg";